import { ElementRef, Directive, HostListener, inject } from '@angular/core'

import { DropdownDirective } from 'app/shared/directives/dropdown.directive'

@Directive({
    selector: '.app-dd-child.dropdown-toggle',
    standalone: false
})
export class DropdownToggleDirective {
    private dropdown = inject(DropdownDirective);
    private elementRef = inject(ElementRef);


    @HostListener('click', ['$event']) onClick($event: any) {
        $event.preventDefault()
        this.dropdown.toggleOpen()
    }

    @HostListener('document:click', ['$event.target']) onClickElsewhere(targetElement) {
        const clickedInside = this.elementRef.nativeElement.contains(targetElement)
        if (!clickedInside) {
            this.dropdown.close()
        }
    }
}
